import { Box, styled } from "@mui/material";

export const ScrollSnap = styled(Box)({
    display: "grid",
    scrollbarWidth: "none",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
        display: "none",
    },
});

export const ScrollSnapItem = styled(Box)({
    scrollSnapAlign: "center",
});
